import Main from '@/components/main'

export default [
  {
    path: '/',
    name: 'main',
    redirect: '/doc',
    component: Main,
    children: [
      {
        path: '/doc',
        name: 'doc',
        component: () => import('@/view/doc')
      },
      {
        path: '/tool',
        name: 'tool',
        redirect: '/tool/call-method',
        component: () => import('@/view/tool'),
        children: [
          {
            path: '/tool/call-method',
            name: 'tool-call-method',
            component: () => import('@/view/tool/call-method')
          },
          {
            path: '/tool/api-test',
            name: 'tool-api-test',
            component: () => import('@/view/tool/api-test')
          },
          {
            path: '/tool/scene/erp',
            name: 'tool-scene-erp',
            component: () => import('@/view/tool/scene/erp')
          },
          {
            path: '/tool/scene/wms',
            name: 'tool-scene-wms',
            component: () => import('@/view/tool/scene/wms')
          },
          {
            path: '/tool/scene/sales',
            name: 'tool-scene-sales',
            component: () => import('@/view/tool/scene/sales')
          },
        ],
      }
    ]
  },
]
